import Vue from "vue";
import Vuex from "vuex"
import menuTree from "./menuTree/index.js"

Vue.use(Vuex);
const store = new Vuex.Store({
  modules:{
      menu:menuTree
  }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js